var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
  pluginRegistry.registerDeploymentAction("Octopus.WildFlyState", function(busy, octopusRepository) {
      return {
          executionLocation: actionExecutionLocations.alwaysOnTarget,
          canChooseRoles: true,
          canHaveChildren: function() { return true; },
          canBeChild: true,
          hasPackages: function(action) { return false; },
          summaryTemplateUrl: "areas/projects/actions/wildfly/Octopus.WildFlyState_summary.html",
          editTemplateUrl: "areas/projects/actions/wildfly/Octopus.WildFlyState_edit.html",
          features: {
              permanent: ["Octopus.Features.WildflyStateCLI"],
              optional: [],
              initial: []
          },
          summaryLink: function ($scope, element) {

          }
      };
    });
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/wildfly/Octopus.WildFlyState.js
// module id = 7902755807180085
// module chunks = 1